export function KindPicker({
  kinds,
  kind,
  onKind,
}: {
  kinds: { kind: string; folder: string }[];
  kind: string | null;
  onKind: (next: { kind: string; folder: string }) => void;
}) {
  return (
    <label className="flex items-center gap-2 px-3 pt-3 text-sm">
      Kind
      <select
        aria-label="Kind"
        value={kind ?? ""}
        onChange={(e) => {
          const picked = kinds.find((option) => option.kind === e.target.value);
          if (picked) onKind({ kind: picked.kind, folder: picked.folder });
        }}
      >
        <option value="" disabled>
          pick a kind
        </option>
        {kinds.map((option) => (
          <option key={option.kind} value={option.kind}>
            {option.kind} ({option.folder})
          </option>
        ))}
      </select>
    </label>
  );
}
